export const m = {
	loginTitle: '登入', //登入
	registerTitle: '创建用户',
	resetPasswordTitle: '重置密码',
	Login: '立即登录',
	Register: '立即注册',
	Rest: '重置密码',
	toResetPassword: '忘记密码?',
	qrCode:'微信登录',
	toLogin: '返回登录页',
	registerSuccess: '注册成功!',
	loginError: '登录失败!',
	emailFormRules: '请输入用户邮箱',
	emailStyleFormRules: '邮箱格式错误',
	passwordFormRules: '请输入密码',
	passwordStyleFormRules: '长度在 6 到 15 个字符',
	confirmPasswordFormRules: '请再次输入密码',
	newPasswordFormRules: '请输入你的新密码',
	resetPasswordError: '重置密码失败!',
	resetPasswordSuccess: '重置密码成功!',
	ComparisonPassword: '两次输入密码不一致',
	code: '请输入验证码',
	codeError: '验证码输入错误!',
	nhpy: '你好,朋友!',
	hyhl: '欢迎回来!',
	xslc: '输入您的个人信息，和我们一起开始旅程!',
	bclx: '为了与我们保持联系，请登录您的个人信息!',
	SentEmail: '已发送邮箱验证码，请查收!',
	SentEmailError: '发送验证码失败!',
	EmailExists: '该邮箱账户已被注册,请更换邮箱账户!',
	EmailUnExists: '该邮箱没有注册,请先注册邮箱账户!',
	emailPlaceholder: '邮箱账号',
	passwordPlaceholder: '密码',
	NewPasswordPlaceholder: '新密码',
	CodePlaceholder: '验证码',
	ConfirmpasswordPlaceholder: '确认密码',
	hqyzm: '获取邮箱验证码',
	xzyy: 'Language 中文',
	zhongwen: '中文',
	yingwen: '英文',
	bt: '上海中烜国际物流有限公司',
	bt1:'全球运价 一键搞定',
	bt11:'专属客服 全程服务',
	bt2:'在这里,您可以查询:',
	bt3:'海运整箱、拼箱、空运、铁路、内陆拖车、国际快递',
	fhshouye:'返回首页',
	
	//导航栏
	HomeText: '首页',
	CompanyText: '公司',
	Contact: '联系我们',
	yjcx: '运价查询',
	hyzx: '海运整箱',
	hypx: '海运拼箱',
	ky: '空运',
	htglxt: '后台管理系统',
	myCenterText: '基本信息',
	xgMyInfo: '修改资料',
	ghtx: '更换头像',
	zzmm: '重置密码',
	wdkf: '我的客服',
	tc: '退出',
	transport: '运输',
	address: '地址',
	Website: '网站',
	e_mail: '邮箱',
	footPhone: '电话热线',
	gywomen: '关于我们',
	navigation: '导航',
	tonavigationdz: 'E通世界商务园华新园D座',
	onlinedz: '在线网址',
	gsjj: '上海中烜国际物流有限公司是一家从事国际货物运输代理,国际船舶代理,装卸搬运等业务的公司，成立于2023年05月05日，公司坐落在上海市，详细地址为：上海市宝山区长江西路2311号1-2层;经国家企业信用信息公示系统查询得知，上海中烜国际物流有限公司的信用代码/税号为91310113MACGJMWJ6R，法人是李张斌，注册资本为550.000000万人民币，企业的经营范围为:一般项目：国际货物运输代理；海上国际货物运输代理；陆路国际货物运输代理；航空国际货物运输代理；国际船舶代理；装卸搬运；集装箱租赁服务；报关业务；无船承运业务；货物进出口；技术进出口；进出口代理。',
	selectLogin:'获取更多的报价,请您注册登录账号！',
	regLogin:'注册/登录',
	//注册
	zcusername: '用户姓名',
	zcusernameplaceholder: '建议使用您的中文姓名',
	//zcusernamerequire:'请输入用户姓名',
	zcusernamerequirestyle: '长度为1到15个字符',
	zcphone: '手机号码',
	zcphoneplaceholder: '请输入11位手机号码',
	//zcphonerequire:'请输入手机号码',
	zcphonerequirestyle: '手机号码格式错误',
	zcbusinessaddress: '经营地址',
	zcbusinessaddressrequire: '请输入公司地址',
	zcbusinessaddressrequirestyle: '长度为1到50个字符',
	zccompany: '公司名称',
	zccompanyrequire: '请输入公司名称',
	zccompanyrequirestyle: '长度为1到20个字符',
	zciaecountries: '进出口国家',
	zciaecountriesrequire: '请输入进出口国家信息',
	zciaecountriesrequirestyle: '长度为1到50个字符',
	zccustomer: '客服',
	zcSales: '选择销售',
	zccustomerrequire: '请选择您的客服',
	zcSalesrequire: '请选择您的销售',
	zczcxx: '注册信息',
	ljzc: '立即注册',
	qxzyhxy: '请阅读且勾选用户协议',
	qxzysxy: '请阅读且勾选隐私协议',
	yhxy: '我已阅读并接受《用户协议》',
	ysxy: '我已阅读并接受《隐私协议》',
	zhanyongphone: '该手机号码已被注册，请更换手机号码!',
	auditsh: '登录账号管理员正在审核中...',
	auditshfail: '登录账号审核未通过',
	zcformconfirmpassword: '确认密码',
	zcformaddress: '公司地址',
	zcformcountry: '进出口国家',
	zcselectrole: '角色',
	zcrolerequire: '请选择你的角色',
	codetimelimit: '验证码失效',
	dlmmcw: '登录密码错误',
	cancel: '取消',
	confirm: '确定',
	sfgb: '是否关闭?',
	grzx: '个人中心',
	out: '退出',
	frozen: '账号冻结！请联系客服解封',
	my: {
		username: '用户名',
		nickname: '昵称',
		company: '所属公司',
		jydz: '经营地址',
		jckgj: '进出口国家',
		create_time: '创建时间',
		last_time: '近一次登录时间',
		myedit: {
			information: '修改资料',
			email: '用户邮箱',
			usernmae: '用户名姓名',
			nickname: '用户昵称',
			phone: '手机号码',
			jydz: '公司地址',
			company: '公司名称',
			jckgj: '进出口国家',
			ljxg: '立即修改',
			tjshxg: '提交审核修改',
			ddsh: '等待审核',
			title: '审核通过失败,请修正错误信息',
			phoneRequired: '请输入用户手机号码',
			phonerule: '请输入合法手机号',
			nicknameRequired: '请输入用户昵称',
			nicknamerule: '用户昵称的长度在1~10字符之间',
			jydzRequired: '请输入公司地址',
			jydzrule: '公司地址必须是1-50位的字符串',
			companyRequired: '请输入公司名称',
			companyrule: '公司名称必须是1-20位的字符串',
			jckgjRequired: '请输入进出口国家',
			jckgjrule: '进出口国家必须是1-50位的字符串',
			phoneexists: '该手机号码已被占用！',
			success: '更新成功！',
			error: '更新用户信息失败！',
			tjcg: '提交审核成功！',
			tjsb: '提交审核失败！',
			phoneTips:'手机号码要与微信号码保持一致,关联到微信登录操作!'
		},
		avatar: {
			avatarname: '更换头像',
			avatarimg: '头像:',
			select: '选择头像',
			upload: '上传头像',
			success: '更新头像成功！',
			error: '更新头像失败！',
			isLt2M:'上传头像图片大小不能超过 2MB!',
			isJPGPNG:'上传头像图片只能是 JPG和PNG 格式!'
		},
		password: {
			passwordname: '重置密码',
			oldpassword: '原密码',
			newpassword: '新密码',
			confirmnewpassword: '确认新密码',
			xgpassword: '修改密码',
			zz: '重置',
			oldpasswordRequired: '请输入原密码',
			newpasswordRequired: '请输入新密码',
			confirmpasswordRequired: '请再次确认新密码',
			passwordRule: '密码长度必须是6-15位的非空字符串',
			newandold: '新旧密码不能相同！',
			errorsame: '两次新密码不一致！',
			updateSuccess: '更新密码成功！',
			updateError: '更新密码失败！'
		}
	},
	logout: {
		ts: '提示',
		tcdl: '您确认退出登录吗？',
		cancel: '取消',
		confirm: '确定',
	},
	t: {
		tl: '铁路',
		nltc: '内陆拖车',
		wtjl: '委托记录',
		gjkd: '国际快递',
		cong: '从',
		dao: '到',
		gq: '港区',
		mddz: '门点地址',
		qxzselect: '请选择',
		Search: '查询',
		jrthhx: '今日特惠航线推荐',
		Port: '港口',
		Hotports: '热门港口',
		Basicport: '基本港口',
		Popularportarea: '热门港区',
		nodata: '无数据',
		Loading: '加载中',
		banquan: '© Copyright 2023上海中烜国际物流有限公司',
		icp: '沪ICP备2023034329号-1',
		company: '公司',
		companyname: '上海中烜国际物流有限公司',
		address: '地址',
		addressname: '上海市松江区九亭镇九泾路959号或洋河浜路501号1幢227室',
		Online: '在线网址',
		phone: '电话',
		pleaseLog:'请您注册/登录账号！'
	},
	card: {
		Customerservice: '专属客服',
		Sales: '专属销售',
		dfp: '待分配',
		qhkf: '切换客服',
		qhxs: '切换销售'
	},
	tjcard: {
		dc: '我要订舱',
		//整箱
		cq: '船期',
		cgs: '船公司',
		zzg: '中转港',
		sxr: '失效日',
		//拼箱
		gj: '国家',
		yjhc: '预计航程',
		khr: '开航日',
		//空运
		hbrq: '航班日期',
		hkgs: '航空公司',
		yjsx: '预计时效',
		//铁路
		bz: '币种',
		bl: '班列',
		//国际快递
		xtwh: '系统维护中，请联系您的专属客服获取报价！',
		nothhx: '当前没有特惠航线'
	},
	queryRequired: {
		polRequired: '请选择起运港！',
		podRequired: '请选择目的港！',
		dockRequired: '请选择港区！',
		trailer_door_pointRequired: '请选择门点地址！'
	},
	Companyprofile: {
		top: '顶部',
		name: '企业简介',
		hyjck: '海运进出口',
		gjky: '国际空运',
		zotl: '中欧铁路',
		zjgcz: '杂件滚船装',
		qqfw: '全球服务',
		Paragraph1: '• 上海中烜国际物流有限公司是经国家交通部批准具备无船承运人经营资格的国家一级货运代理企业。是在上海、重庆、武汉、南京、天津、青岛、宁波、广州、深圳等口岸专业从事国际货物运输代理的企业。公司以提供国际海运、国际空运、国际铁路运输进口及出口代理为业务核心，运营多年来，在公司全体同仁的共同协作下，建立了国内主要口岸操作一体化的运作体系。上海中烜国际物流有限公司确定了“立足上海，服务全国，放眼世界”的企业目标，以发展更专业的国际物流为企业使命，提供物流配送、供应、仓储、分拨、供应链管理、综合物流咨询及设计。公司具有现代化的企业管理，拥有经验丰富、业务娴熟的专业队伍，全心为您提供最适当的方案、专业建议及可靠的服务。',
		Paragraph2: '• 主营业务：海运进出口；空运进出口；中欧铁路进出口；件杂滚装运输。',
		Paragraph3: '• 中烜物流立足上海，公司距上海外港码头仅20分钟车程。不管是进口业务还是出口业务，只要遇到海关查验，中烜物流将第一时间出现在查验现场，为您的货物通关提供保驾护航服务。',
		Paragraph4: '• 中烜物流有完善的海外代理网络，不管您是出口DAP、DDU、DDP；还是进口EXW、FOB，我们都会为您提供最安全的运输、最快捷的通关服务。',
		Paragraph5: '• 中烜物流有丰富的亚马逊货物（FBA）操作经验，在安全快捷的基础上，可以为您节省更多不必要的支出。',
		Paragraph6: '• 中烜物流有丰富的化工品、危险品操作经验，随时为您解决化工品订舱审批慢等问题。',
		Paragraph7: '• 中烜物流有开顶箱、框架箱、冷箱等特种箱业务。',
		Paragraph8: '• 全球主要机场进口、出口空运代理服务。',
		Paragraph9: '• 提供私人物品空运代理服务。',
		Paragraph10: '• 支持化工品、危险品业务。',
		Paragraph11: '• 代办化工鉴定、危包证。',
		Paragraph12: '• 满足全球门到门服务。',
		Paragraph13: '• 郑州、武汉、成都、重庆、苏州、义乌、上海。',
		Paragraph14: '• 整箱有华沙、明斯克、布列斯特、米兰、汉堡、莫斯科、圣彼得堡、慕尼黑、马拉舍维奇、布达佩斯等。',
		Paragraph15: '• 拼箱辐射欧洲全境门到门。',
		Paragraph16: '• 支持铁路进口、出口服务。',
		Paragraph17: '• 天津、大连、青岛、连云港、南京、南通、张家港、上海、厦门、广州等。',
		Paragraph18: '• HANDY、MPP等各种船型选择。',
		Paragraph19: '• FLT、FILO、FIO、LIFO等各种条款。',
		Paragraph20: '• 码头地面服务、捆扎服务、打尺服务。',
		Paragraph21: '• 中烜物流拥有多家固定合作的海外代理，广泛分布于美洲、欧洲、非洲、中东、中亚、东亚及东南亚等60多个国家和地区。',

	},
	contact: {
		us: '联系我们',
		tsdh: '投诉电话'
	},
	tips: {
		dsh: '注册信息待审核,请联系您的专属销售审核通过,即可查价',
		dsh1: '注册信息待审核,请联系您的专属销售审核通过',
		shbtg: '注册信息审核不通过,请联系您的专属销售',
		rqsx: '日期失效'
	},
	tabletext: {
		table_empty_text: '请搜索相关信息查询价格!',
		table_empty_text1: '暂无匹配报价商品,请联系您的专属客服为您报价和添加对应报价信息!',
		table_loading: '拼命加载中'
	},
	entrustment: {
		title: '提示',
		selectMethod: '请选择您的订舱方式!',
		selectone: '填写委托信息',
		selecttwo: '请专属客服与我联系',
		selecttwoSuccess: '您的专属客服将在半小时内联系您!',
		selecttwoError: '我要订舱操作失败！',
		entrustmentWrite: {
			title: '出运委托书',
			tabone: '填写委托书',
			tabtwo: '不填写委托书(仅上传委托书)',
			transportation: '运输方式:',
			fcl: '海运整箱',
			lcl: '海运拼箱',
			air: '空运',
			railway: '铁路',
			trailers: '内陆拖车',
			express: '国际快递',
			boxVolume: '箱型*箱量:',
			Inside: '内',
			OtherSize: '其它规格',
			OtherSizeRequired: '请输入其它规格',
			mz: '毛重',
			tj: '体积',
			packages: '包装件数',
			zwpm: '中文品名',
			ywpm: '英文品名',
			bm: '十位HS编码',
			fhrxx: '发货人信息',
			fhrxxRequired: '请填写发货人信息',
			shrxx: '收货人信息',
			shrxxRequired: '请填写收货人信息',
			tzrxx: '通知人信息',
			tzrxxRequired: '请填写通知人信息',
			Upload: '上传附件:',
			szwts: '上传委托书',
			Preview: '预览文件',
			Confirm: '确定',
			cancel: '取消',
			qxztransportationRequired: '请选择运输方式！',
			submissionfailed: '提交委托书失败！',
			submissionsuccess: '感谢您的委托！专属客服将在半小时内与您联系！！',
			limit: '上传的文件大小不能超过5MB!',
			ConsignmentRecord: {
				name: '出运委托书记录',
				queryRequired: '请输入内容',
				index: '序号',
				nameModule: '出运委托业务模块',
				transportation: '运输方式',
				pol: '起运港',
				pod: '目的港',
				createTime: '提交委托时间',
				username: '用户名',
				phone: '用户手机号码',
				email: '用户邮箱',
				kf: '专属客服',
				cz: '操作',
				check: '查看详情'
			}
		}
	},
	fcl: {
		name: '海运整箱',
		from: '从',
		to: '到',
		inquiry: '查询',
		lssearch: '历史搜索',
		nolssearch: '无历史搜索记录',
		sxtj: '筛选条件',
		qxz: '请选择船公司',
		xsqb: '显示全部',
		jkzd: '仅看直达',
		jkzz: '仅看中转',
		POL: '起运港',
		POD: '目的港',
		mdggq: '目的港港区',
		cq: '船期',
		cgs: '船公司',
		zzg: '中转港',
		yjhc: '预计航程',
		qymt: '起运码头',
		wydc: '我要订舱',
		yxq: '有效期',
		dcf: '订舱费',
		qf: '铅封',
		wjf: '文件费',
		cdf: '舱单费',
		remark: '备注',

	},
	lcl: {
		name: '海运拼箱',
		from: '从',
		to: '到',
		inquiry: '查询',
		lssearch: '历史搜索',
		nolssearch: '无历史搜索记录',
		sxtj: '筛选条件',
		xsqb: '显示全部',
		jkzd: '仅看直达',
		jkzz: '仅看中转',
		//*************************
		POL: '起运港',
		POD: '目的港',
		gj: '国家',
		hl: '货量',
		tjj: '体积价',
		zlj: '重量价',
		jdsj: '截单时间',
		jhsj: '截货时间',
		khr: '开航日',
		zzg: '中转港',
		yxq: '有效期',
		yjhc: '预计航程',
		wydc: '我要订舱',
		remark: '备注',

	},
	air: {
		name: '空运',
		from: '从',
		to: '到',
		inquiry: '查询',
		lssearch: '历史搜索',
		nolssearch: '无历史搜索记录',
		sxtj: '筛选条件',
		qxzhkgs: '请选择航空公司',
		xsqb: '显示全部',
		jkzd: '仅看直达',
		jkzz: '仅看中转',
		//*************************
		ztxx: '主体信息',
		jgxx: '价格信息',
		POL: '起运港',
		POD: '目的港',
		gj: '国家',
		hggs: '航空公司',
		hbrq: '航班日期',
		zzg: '中转港',
		yjsx: '预计时效',
		yxq: '有效期',
		gxrq: '更新日期',
		hb: '货比',
		sh: '散货',
		tp: '托盘',
		wydc: '我要订舱',
		lj: '路径',
		remark: '备注',
	},
	railway: {
		name: '铁路',
		from: '从',
		to: '到',
		inquiry: '查询',
		lssearch: '历史搜索',
		nolssearch: '无历史搜索记录',
		sxtj: '筛选条件',
		//*************************
		POL: '起运港',
		POD: '目的港',
		bz: '币种',
		bl: '班列',
		yjhc: '预计航程',
		yxq: '有效期',
		wydc: '我要订舱',
		remark: '备注',
	},
	trailer: {
		name: '内陆拖车',
		from: '港区',
		to: '门点地址',
		inquiry: '查询',
		lssearch: '历史搜索',
		nolssearch: '无历史搜索记录',
		sxtj: '筛选条件',
		//*************************
		sxr: '生效日',
		shixiaor: '失效日',
		wydc: '我要订舱',
		remark: '备注',
	},
	express: {
		name: '国际快递',
		from: '起始地',
		to: '目的地',
		weight: '重量',
		inquiry: '查询',
		lssearch: '历史搜索',
		nolssearch: '无历史搜索记录',
		sxtj: '筛选条件',
		// //*************************
		country:'国家',
		category: '网络类别',
		StandardPrice:'标准价格',
		discount:'折扣',
		fuel:'燃油费',
		totalcost:'总费用',
		valid:'有效期',
		sxrq:'失效日',
		volume:'按体积',
		wydc: '我要订舱',
		remark: '备注',
        qxzweight:'请选择重量！',
		weightLimit:'重量不能大于299KG！',
		qxzmdd:'请选择目的地！'

	},
	Loginalert:{
		tologin:'立即登录，查看运价',
		title:'已查询到丰富运价，更有历史运价，助您快速了解行情'
	},
	kf:{
		addwx:'添加微信',
		Customerservice: '专属客服',
		name1:'刘北国 Leo',
		tel1:'13636357858',
		qq1:'3004700277',
		email1:'Leo@zx-cargo.com',
		name2:'李张斌 Polo',
		tel2:'18816969858',
		qq2:'3004703831',
		email2:'polo@zx-cargo.com',
		name3:'马晓黎 Kitty',
		tel3:'13601783800',
		qq3:'3004753719',
		email3:'Kitty@zx-cargo.com'
	}
}